import { formatDate } from '@angular/common';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as AppState from '../../_state/app.state';
import { ClasePerdidaState } from './clase-perdida.reducer';

// Extends the app state to include the ClasePerdida feature.
// This is required because ClasePerdida are lazy loaded.
// So the reference to ClasePerdidaState cannot be added to app.state.ts directly.
export interface State extends AppState.State {
    clasePerdidas: ClasePerdidaState;
}

// Selector functions
export const getClasePerdidaFeatureState = createFeatureSelector<ClasePerdidaState>('clasePerdidas');

export const getIdUnidad = createSelector(
    getClasePerdidaFeatureState,
    state => state.idUnidad
);

export const getCurrentClasePerdidaId = createSelector(
    getClasePerdidaFeatureState,
    state => state.currentClasePerdidaId
);

export const getCurrentClasePerdida = createSelector(
    getClasePerdidaFeatureState,
    getCurrentClasePerdidaId,
    (state, currentClasePerdidaId) => {
        if (currentClasePerdidaId === 0) {
            return {
                id: 0,
                unidadID: getIdUnidad,
                materiaCursoPeriodoID: null,
                fecha: formatDate
                    (new Date(), 'yyyy-MM-dd', 'es_CO'),
                motivo: '',
                horas: 1,
                isActive: true
            };
        } else {
            return currentClasePerdidaId
                ? state.perdidas.find(c => c.id === currentClasePerdidaId)
                : null;
        }
    }
);

export const getClasePerdidas = createSelector(
    getClasePerdidaFeatureState,
    state => state.perdidas
);

export const getUnidadMaterias = createSelector(
    getClasePerdidaFeatureState,
    state => state.materias
);

export const getLoading = createSelector(
    getClasePerdidaFeatureState,
    state => state.loading
);

export const getError = createSelector(
    getClasePerdidaFeatureState,
    state => state.error
);
